export const tabList = ["日语", "韩语", "德语", "法语", "西语", "意语", "俄语"]
export const posterList = [
  { name: "水平评测", bgColor: "#e99eb5", icon: require('../assets/static/nav-list/nav-01.png') },
  { name: "考试介绍", bgColor: "#85cbee", icon: require('../assets/static/nav-list/nav-02.png') },
  { name: "考试月历", bgColor: "#e8b92f", icon: require('../assets/static/nav-list/nav-03.png') },
  { name: "考试费用", bgColor: "#2c61ad", icon: require('../assets/static/nav-list/nav-04.png') },
  { name: "课程日历", bgColor: "#8bc33e", icon: require('../assets/static/nav-list/nav-05.png') },
  { name: "免费试听", bgColor: "#52296f", icon: require('../assets/static/nav-list/nav-06.png') },
]
export const referralList = [
  {
    name: "日语",
    id: "Japanese",
    alias: "日语",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "日语入门课程",
      icon: require("../assets/static/lang-icon/ry-01.png"),
      referral: "本课程主要设置班课及vip课程，基本发音/数字/时间；初步了解日本人的思维方式和表达特点；掌握日语基础语法知识，能进行简单对话和阅读，书写非常简单短小的文章"
    }, {
      name: "日语能力考",
      alias: "日本能力考",
      icon: require("../assets/static/lang-icon/ry-02.png"),
      referral: "课程主要设置为班课及VIP课程，学习完本课程可熟悉掌握N5-N1阶段知识点，参与JLPT考试"
    }, {
      name: "单项提升课程",
      alias: "单项提升课程",
      icon: require("../assets/static/lang-icon/ry-03.png"),
      referral: "本课程主要会分别针对各个单项的知识点进行分解，提高日语综合能力；针对学员情况进行查漏补缺精讲精练"
    }]
  },
  {
    name: "韩语",
    id: "Korean",
    alias: "韩语",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "韩语入门课程",
      icon: require("../assets/static/lang-icon/hy-01.png"),
      referral: "本课程主要为韩语入门级别课程，通过本课程学习，基本能够与韩国人进行日常生活沟通"
    }, {
      name: "留学课程",
      alias: "韩语留学课程",
      icon: require("../assets/static/lang-icon/hy-02.png"),
      referral: "本课程设置主要是针对韩语TOPIK考试，设置为T1-T6级别课程的班课及VIP课程"
    }, {
      name: "兴趣课程",
      alias: "韩语兴趣课程",
      icon: require("../assets/static/lang-icon/hy-03.png"),
      referral: "本课程主要针对兴趣爱好者，企业培训等人群开设"
    }]
  },
  {
    name: "德语",
    id: "German",
    alias: "德语",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "德语入门课程",
      icon: require("../assets/static/lang-icon/dy-01.png"),
      referral: "本课程为德语入门级别课程（A1-A2)，开设有班课及一对一，教授德语基础的发音，语法，听说，写作等内容"
    }, {
      name: "德福课程",
      alias: "德福课程课程",
      icon: require("../assets/static/lang-icon/dy-02.png"),
      referral: "本课程主要为德福冲刺课程，针对听说读写各项进行精讲精练"
    }, {
      name: "兴趣课程",
      alias: "德语兴趣课程",
      icon: require("../assets/static/lang-icon/dy-03.png"),
      referral: "本课程主要针对兴趣爱好者，企业培训等人群开设"
    }]
  },
  {
    name: "法语",
    id: "French",
    alias: "法语",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "法语入门课程",
      icon: require("../assets/static/lang-icon/fy-01.png"),
      referral: "本课程为法语入门级别课程（A1-A2)，开设有班课及一对一，教授法语基础的发音，语法，听说，写作等内容"
    }, {
      name: "TCF/TEF课程",
      alias: "TCF/TEF课程",
      icon: require("../assets/static/lang-icon/fy-02.png"),
      referral: "本课程主要为针对TCF/TEF考试为主，开设有班课及一对一"
    }, {
      name: "兴趣课程",
      alias: "法语兴趣课程",
      icon: require("../assets/static/lang-icon/fy-03.png"),
      referral: "本课程主要针对兴趣爱好者，企业培训等人群开设"
    }]
  },
  {
    name: "西语",
    id: "Spanish",
    alias: "西语",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "西语入门课程",
      icon: require("../assets/static/lang-icon/xy-01.png"),
      referral: "本课程为西语入门级别课程（A1-A2)，开设有班课及一对一，教授西语基础的发音，语法，听说，写作等内容"
    }, {
      name: "DELE课程",
      alias: "DELE课程课程",
      icon: require("../assets/static/lang-icon/xy-02.png"),
      referral: "本课程主要为针对DELE考试为主，开设有班课及一对一，通过日常学习及课程中的听说读写专项训练，顺利通过考试"
    }, {
      name: "Siele考前辅导",
      alias: "SIELE考前辅导课程",
      icon: require("../assets/static/lang-icon/xy-03.png"),
      referral: "本课程主要针对兴趣爱好者，企业培训等人群开设"
    }]
  },
  {
    name: "意语",
    id: "Italian",
    alias: "意语",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "意语入门课程",
      icon: require("../assets/static/lang-icon/yy-01.png"),
      referral: "本课程为意语入门级别课程（A1-A2)，开设有班课及一对一，教授意语基础的发音，语法，听说，写作等内容"
    }, {
      name: "留学课程",
      alias: "留学课程",
      icon: require("../assets/static/lang-icon/yy-02.png"),
      referral: "本课程为意大利留学语言等级（A1-B2)，开设有班课及一对一，顺利拿到欧标等级需求"
    }, {
      name: "兴趣课程",
      alias: "兴趣课程",
      icon: require("../assets/static/lang-icon/yy-03.png"),
      referral: "本课程主要针对兴趣爱好者，企业培训等人群开设"
    }]
  },
  {
    name: "俄语、葡语",
    id: "Russian-Portuguese",
    alias: "俄葡",
    referral: "多种课程提供给不同小语种需求的学生，可根据学生的具体情况来定课程方案",
    child: [{
      name: "入门课程",
      alias: "俄葡入门课程",
      icon: require("../assets/static/lang-icon/epy-01.png"),
      referral: "本课程为俄葡语入门级别课程（A1-A2)，开设有班课及一对一，教授基础的发音，语法，听说，写作等内容"
    }, {
      name: "留学课程",
      alias: "俄葡留学课程",
      icon: require("../assets/static/lang-icon/epy-02.png"),
      referral: "本课程为俄葡留学语言等级（A1-B2)，开设有班课及一对一，顺利拿到欧标等级需求"
    }, {
      name: "兴趣商务课程",
      alias: "俄葡兴趣课程",
      icon: require("../assets/static/lang-icon/epy-03.png"),
      referral: "本课程主要针对兴趣爱好者，企业培训等人群开设"
    }]
  },
]
export const selectList = [
  {
    content: "练习地道口语<br>日常场景对话",
    icon: require("../assets/static/select-icon/select-01.png")
  },
  {
    content: "语言能力考全掌握<br>需考知识",
    icon: require("../assets/static/select-icon/select-02.png")
  },
  {
    content: "很多为对外企事业单位<br>对懂得外国语言的<br>人才需求较多",
    icon: require("../assets/static/select-icon/select-03.png")
  },
  {
    content: "学习周期时间短<br>有很多小语种学习难度低<br>对于英语基础不好的学生是个机会",
    icon: require("../assets/static/select-icon/select-04.png")
  },
]
export const FQAList = [
  {
    title: "对小语种很有兴趣，但不知道怎么开始学？",
    content: "非凡小语种会在一开始为学员进行专业语言水平测评，为学员提供专业的课程规划，并且有SA进行跟踪服务的，以完全不用担心学习新语言没有方向哦。"
  },
  {
    title: "老师平时在课堂中如何教学，课堂气氛怎么样？",
    content: "非凡老师会在课堂循序渐进地激发大家对小语种的学习的兴趣，配合着多媒体平台引导大家轻松表达自我。。"
  },
  {
    title: "课程每个阶段目标是什么？如何了解自己的水平？",
    content: "非凡课堂为每一个级别都设置了清晰的学习目标，严谨的学习计划、阶段性测试、阶段性分分析、考前心理辅导、日常学习解压。"
  },
  {
    title: "能开课时证明吗？",
    content: "每个等级结课后可开出结业证书、也可以开出使馆认可的课时证明"
  },
]
export const advantageList = [
  {
    content: "有经验的教学团队<br>有针对性的练习",
    icon: require("../assets/static/advantage-icon/advantage-01.png")
  },
  {
    content: "多样化课堂内容<br>线上线下课程",
    icon: require("../assets/static/advantage-icon/advantage-02.png")
  },
  {
    content: "细致服务<br>跟踪反馈",
    icon: require("../assets/static/advantage-icon/advantage-03.png")
  },
  {
    content: "阶段性测试<br>定期学习计划",
    icon: require("../assets/static/advantage-icon/advantage-04.png")
  },
  {
    content: "规划方案定制课程<br>适时调整学习方向",
    icon: require("../assets/static/advantage-icon/advantage-05.png")
  },
  {
    content: "课程内容规划<br>课程教学体系",
    icon: require("../assets/static/advantage-icon/advantage-06.png")
  }
]